import '../../blocks/installer-form/installer-form.scss';
import '../../blocks/ring-breadcrumbs/ring-breadcrumbs.scss';
import InstallerResource from '../../blocks/resource/resource';
import ExternalValidator from '../../blocks/external-validator/external-validator';
import StartInstallation from '../../blocks/start-installation/start-installation';
import WizardInfo from '../../blocks/wizard-info/wizard-info';

import LicenseTemplate from './license.html';
import './license.scss';

import LicenseController from './license__controller';

export default angular.module('installer.license', [
  InstallerResource.name,
  WizardInfo.name,
  ExternalValidator.name,
  StartInstallation.name
]).
  controller('LicenseController', LicenseController).
  config($routeProvider => {
    $routeProvider.
      when('/install/license', {
        template: LicenseTemplate,
        controller: 'LicenseController as ctrl',
        reloadOnSearch: false
      }).
      when('/upgrade/license', {
        template: LicenseTemplate,
        controller: 'LicenseController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/license/license.js